<template>
    <div>
         
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    created: function() {
        this.logout()
    },
    methods:{
        ...mapActions([
            'logout'
        ]),
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Logout.vue?185cf552